export interface ConfidenceInputs {
    vehicleData: {
        hasVin: boolean;
        isComplete: boolean; // all specs filled
    };
    fieldTests: {
        performed: number;
        isValid: boolean; // sensor values within range
    };
    historicalMatch: boolean;
    messageClarity: number; // 0-1 scale
}

/**
 * ConfidenceEngine
 * Calculates a trust score (0-100) to guide the AI's assertiveness.
 */
export const confidenceEngine = {
    /**
     * Calculates the final confidence score
     */
    calculateScore(inputs: ConfidenceInputs): number {
        let score = 0;

        // 1. Vehicle Fingerprint (Weight: 25%)
        if (inputs.vehicleData.hasVin) score += 15;
        if (inputs.vehicleData.isComplete) score += 10;

        // 2. Field Tests (Weight: 35%)
        if (inputs.fieldTests.performed > 0) score += 15;
        if (inputs.fieldTests.isValid) score += 20;

        // 3. Historical Data (Weight: 20%)
        if (inputs.historicalMatch) score += 20;

        // 4. Input Quality (Weight: 20%)
        score += (inputs.messageClarity * 20);

        return Math.min(Math.round(score), 100);
    },

    /**
     * Determines the tone and access level based on score
     */
    getActionThresholds(score: number) {
        return {
            isAssertive: score >= 80,
            unlockAdvancedSteps: score >= 70,
            requiresMoreQuestions: score < 50,
            label: score >= 80 ? 'Confirmed' : score >= 50 ? 'Estimated' : 'Tentative'
        };
    },

    /**
     * Formats the confidence for the Sudanese persona
     * "أبشر، المكنة واضحة" vs "دايرة فحص زيادة"
     */
    getPersonaFeedback(score: number): string {
        if (score >= 85) return "أبشر يا بطل، المشكلة واضحة والحل عندي.";
        if (score >= 60) return "يا هندسة، بنسبة كبيرة دي العلة، بس جرب الخطوات دي أول.";
        return "يا زول، البيانات دي لسه ما كافية، محتاجين نتأكد من كم حاجة.";
    }
};
